// Calculates the required offset for the anchor
function getOffset(element) {
  const siteNotice = document.querySelector(".site-notice");
  const siteNoticeHeight = siteNotice ? siteNotice.offsetHeight : 0;
  const menuPanel = document.querySelector(".menu__panel");
  const menuPanelHeight = menuPanel ? menuPanel.offsetHeight : 0;
  return element.offsetTop - siteNoticeHeight - menuPanelHeight - 20;
}

// Scrolls to the target element
function scrollToTargetElement(targetElement) {
  const offset = getOffset(targetElement);
  window.scrollTo({ top: offset, behavior: "smooth" });
}

// Catches the hash change event and scrolls to the target element
function removeAnchorFromUrlAndScrollTo() {
  const url = window.location.href;
  const anchorIndex = url.lastIndexOf("#");

  if (anchorIndex !== -1) {    

    // Scroll to the target element immediately after removing the anchor
    const targetId = url.substring(anchorIndex + 1);
    const targetElement = document.getElementById(targetId);
    //There is a conflict with the CIW wizard so lets exclude removing step anchors
    if (targetElement && (targetElement.className !="step")) {
      const newUrl = url.substring(0, anchorIndex);
      window.history.replaceState({}, document.title, newUrl);
      scrollToTargetElement(targetElement);
    }
  }
}

// Remove anchor from URL as soon as possible to prevent default scroll behaviour
removeAnchorFromUrlAndScrollTo();

// Hashchange happens if an anchor is clicked in the same page- we can directly remove the anchor. Note we don't need to listen to clicks as this runs on hash change
window.addEventListener("hashchange", removeAnchorFromUrlAndScrollTo);
